import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
import { InstitutionsService } from '@app/services/institutions/institutions.service';
import { Member, MemberShort } from '@app/models/member';
import { Subscription } from 'rxjs';
import { Sort } from '@angular/material/sort';
import { Enumroles } from '@app/models/enumroles.enum';
import { ClaimsService } from '@app/services/claims/claims.service';
import { MemberService } from '@app/services/member.service';
import { SnackbarService } from '@app/services/shared/snackbar.service';
import { ActivatedRoute } from '@angular/router';
import { PlatformLocation } from '@angular/common';
import { SortService } from '@app/components/sorting/SortService';

interface InstitutionInfo {
  id: number;
  shortname: string;
  name: string;
}

interface NewMembers {
  memberId: number;
  startDate: string;
  institutionId: number;
  action: string;
}

interface LodgeAndCamp {
  id: number;
  shortName: string;
  name: string;
}

@Component({
  selector: 'app-nymedlem',
  templateUrl: './nymedlem.component.html',
  styleUrls: ['./nymedlem.component.css']
})
export class NymedlemLagerComponent implements OnInit, OnDestroy {
  memberlist: Member[] = [];
  members: MemberShort[] = [];
  institutionlist: LodgeAndCamp[] = [];
  memberidlist: NewMembers[] = [];
  minmaxyear = { minYear: '1920', maxYear: '2030' };
  autoCorrectedDatePipe = createAutoCorrectedDatePipe('yyyy-mm-dd', this.minmaxyear);
  public mask = [/[1-9]/, /\d/, /\d/, ' ', /\d/, /\d/]; // zipcode
  public maskdatum = [/[129]/, /[?09]/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/];

  subscriptions: Subscription[] = [];
  baseinfo;

  brothercamplist: LodgeAndCamp[] = [];
  rebeckacamplist: LodgeAndCamp[] = [];
  institutiontype: number;
  valid = false;
  title: string;
form;
institutiontypeid: number;
  // tslint:disable-next-line:max-line-length
  constructor(
    private fb: FormBuilder,
    private institutionsService: InstitutionsService,
    private location: PlatformLocation,
    private route: ActivatedRoute,
    private claimsService: ClaimsService,
    private memberService: MemberService,
    private snackbarService: SnackbarService) {

    this.subscriptions.push(this.claimsService.claims$.subscribe(data => {
      if (data) {
        this.baseinfo = data;
        this.listClaims();
      }
    }));
  }

  
  institutionid;
  institutionname;
  institutionshortname;
  ngOnInit() {
    this.form = this.fb.group({
      startDate: ['', Validators.required],
      campId: ['', ''],
      memberId: ['', ''],
      givenName: ['', ''],
      familyName: ['', ''],
      institutionId: ['', ''],
      institutionType: ['', '']
    });
    this.route.params.subscribe(p => {
      if (p) {
        this.institutionid = p.id;
        this.institutionsService.getInstitutionByIdAsync(this.institutionid).subscribe(i => {
this.institutiontypeid = i.institutionTypeId;
          this.institutionname = i.name;
          this.institutionshortname = i.shortName;
          let typeid;
          if (i.institutionTypeId === 5 || i.shortName.startsWith('B')) {
            typeid = 1;
          } else {
            typeid = 2;
          }
          this.form.patchValue({ institutionType: typeid });
          this.form.patchValue({ campId: this.institutionid });
          this.setInstitutionType(typeid);
        });
      }
    });
    // Hämta brödraläger

    this.subscriptions.push(this.institutionsService.GetAllCampsAndAssociationsAsync(1).subscribe(data => {
      data.forEach(element => {
        const inst = { id: element.id, shortName: element.shortName, name: element.name };
        this.brothercamplist.push(inst);
      });
    }
    ));

    // Hämta Rebeckaläger
    this.subscriptions.push(this.institutionsService.GetAllCampsAndAssociationsAsync(2).subscribe(data => {
      data.forEach(element => {
        const inst = { id: element.id, shortName: element.shortName, name: element.name };
        this.rebeckacamplist.push(inst);
      });
    }
    ));
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => {
      sub.unsubscribe();
    });
  }

  setTitle(evt: any) {
    this.title = evt.target.options[evt.target.selectedIndex].text;
  }

  listClaims() {
    this.baseinfo.claimsList.forEach(element => {
      
      if (element.key === Enumroles.ADMIN_CAMP) {
        const lodgeOrcamp: LodgeAndCamp = {
          id: element.value.id,
          shortName: element.value.shortName,
          name: element.value.name
        };
        this.institutionlist.push(lodgeOrcamp);
      }
    });
  }

  addItem(member: MemberShort): void {
    this.members.push(member);
  }

  add(selectedmember, element) {
    if (element.checked) {
      if (!this.checkMember(selectedmember.id)) {
        this.addItem(selectedmember);
      }
    } else {
      this.removeFromArray(selectedmember.id);
    }
  }

  checkMember(memberid: number) {
    return this.members.find(item => item.id === memberid);
  }

  removeFromArray(id: number) {
    const idx = this.members.findIndex(item => item.id === id);
    this.members[idx].checked = false;
    this.members.splice(idx, 1);
    // this.removeSelectedMember(id);
  }

  search() {

    // tslint:disable-next-line:max-line-length
    if (this.form.get('campId').value === null) {
      this.form.patchValue({ campId: this.institutionid });
    }
    const searchdata = { campId: this.form.get('campId').value, memberSearch: { institutionId: this.form.get('institutionId').value, memberId: this.form.get('memberId').value, givenName: this.form.get('givenName').value, familyName: this.form.get('familyName').value, startDate: this.form.get('startDate').value} };
    if(this.institutiontypeid == 7 || this.institutiontypeid == 15) {
      this.subscriptions.push(this.institutionsService.SearchMembersForAssociationAsync(searchdata).subscribe(data => {
        this.memberlist = data.membersToAdd;
      }));
    }
    else if (searchdata.campId !== '142' && searchdata.campId !== '63' && searchdata.campId !== '143' && searchdata.campId !== '108') {
      this.subscriptions.push(this.institutionsService.SearchMembersForCampAsync(searchdata).subscribe(data => {
        this.memberlist = data.membersToAdd;
      }));
    } else {

      this.subscriptions.push(this.institutionsService.SearchMembersForSLAsync(searchdata).subscribe(data => {
        this.memberlist = data.membersToAdd;
      }));
    }
  }

  saveNewMembers() {
    const installationdate = this.form.get('startDate').value;
    //  const institutionid = this.form.get('institutionId').value;
    this.memberidlist = [];

    this.members.forEach(item => {
      const newmember: NewMembers = {
        memberId: item.id,
        institutionId: Number(this.form.get('campId').value),
        startDate: installationdate,
        action: 'add'
      };
      this.memberidlist.push(newmember);
    });

    this.subscriptions.push(this.memberService.updateMemberMembership(this.memberidlist).subscribe(response => {
      let count = 0;
      if (response) {
        response.forEach(element => {
          if (element.rowsAffected > 0) {
            count++;
          }
        });
        this.snackbarService.openSnackBar(count + ' av ' + response.length + ' poster tillagda.', null);
        this.memberlist = [];
        this.members = [];
      }
    }));
  }

  sortData(sort: Sort) {
    const data = this.memberlist.slice();
    if (!sort.active || sort.direction === '') {
      this.memberlist = data;
      return;
    }

    this.memberlist = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'id': return this.compare(a.id, b.id, isAsc);
        case 'givenName': return this.compare(a.givenName, b.givenName, isAsc);
        case 'familyName': return this.compare(a.familyName, b.familyName, isAsc);
        default: return 0;
      }
    });
  }

  compare(a: number | string | Date, b: number | string | Date, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }


  setInstitutionType(type: number) {

    this.institutionlist = [];
    this.institutiontype = type;
    //SL1 eller EGL1 eller SGL1
    if (this.institutionid === '142' || this.institutionid === '63' || this.institutionid === '143' || this.institutionid === '108') {

      this.institutiontype = 0;
    }
    // Hämta primärloger utifrån val av institutionstyp
    this.subscriptions.push(this.institutionsService.GetAllPrimaryLodgesAsync(this.institutiontype).subscribe(data => {

      data.forEach(element => {
        const inst = { id: element.id, shortName: element.shortName, name: element.name };
        this.institutionlist.push(inst);
      });
      this.institutionlist = this.institutionlist.sort((a, b) => {
        return SortService.cmpStringsWithNumbers(a.shortName, b.shortName, false);
      });
      const removelist = ['AV1', 'AVGBREV1', 'UT1', 'EL', 'ELA', 'K', 'RLK1', 'RR1', 'SOFT1', 'SOFT2', 'SL1', 'EL1', 'EL2', 'EL3', 'EL4', 'EL5', 'EL10', 'EL11', 'EL12', 'EL13'];
      this.institutionlist = this.institutionlist.filter(x => {
        return removelist.indexOf(x.shortName) === -1;
      });
      // this.institutionlist.sort((current, next)=>{ return current.shortName.localeCompare(next.shortName)});
    }
    ));
    this.valid = this.form.valid;
  }

  cancel() {
    this.location.back();
  }
}
